import { render } from "./SelectComponent.vue?vue&type=template&id=0b4a6e0e&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=0b4a6e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4a6e0e"]])

export default __exports__